import { MATERIAL_THICKNESS,  BLEED } from "./constants.js"
import { 
  toPx, 
  calculateSecondPointYFromAngleAndDistance, 
  calculateSecondPointXFromAngleAndDistance 
} from "./utils/common.js"
import { BOX_TYPES } from "./BoxTypes.js"

import * as svgGenerator from "./svgGenerator/pizzaBoxGenerator.js";

import Base from "./Base";
import Panel from "./Panel";

class PizzaBox extends Base {
  // maximumFlapWidth = 0;
  // maximumFlapWidthInPx = 0;
  // flapWidth = 0;
  // flapWidthInPx = 0;
  overlapWidth = 0;
  overlapWidthInPx = 0;
  cutOutWidth = 0.75;
  cutOutWidthInPx = 0.75 * this.pixelsPerInch;

  constructor(params) {
    super(params);

    this.type = BOX_TYPES.PIZZA;

    this.overlapHeight = MATERIAL_THICKNESS * 3;
    this.overlapHeightInPx = this.overlapHeight * this.pixelsPerInch;

    // this.setFlapDimensions();
    this.setCanvasDimensions();
    this.setControlsSize();
    this.panels = this.getPanels();
  }

  getPanels() {
    // const {
    //   x: guideX,
    //   y: guideY
    // } = this.getGuidePoint()

    // Get box W, L, D, for simplicity
    const {
      width: W,
      length: L,
      depth: D,
    } = this;

    const CUT_OUT_WIDTH = this.cutOutWidth
    // const CIRCLE_RADIUS = 1

    // panel config objects
    let panels = [
      {
        name: "frontLeftFlap",
        // row: 'first',
        print: false,
        printInside: false,
        width: D - MATERIAL_THICKNESS,
        height: 2*D + 2*MATERIAL_THICKNESS,
        top: BLEED,
        left: BLEED,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "none",
        cameraRotationV: "none",
        lid: "current",
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + D - 2*MATERIAL_THICKNESS}
            L ${this.left + this.width - 2*MATERIAL_THICKNESS} ${this.top + D - 2*MATERIAL_THICKNESS + 3*MATERIAL_THICKNESS}
            L ${this.left + this.width - 2*MATERIAL_THICKNESS} ${this.top + this.height - 2*MATERIAL_THICKNESS}
            L ${this.left + this.width - MATERIAL_THICKNESS} ${this.top + this.height}
            L ${this.left} ${this.top + this.height}
            L ${this.left} ${this.top}
            Z
          `
        }
      },
      {
        name: "insideFrontWall",
        // row: 'first',
        print: false,
        printInside: false,
        width: L + 2*MATERIAL_THICKNESS,
        height: D - 2*MATERIAL_THICKNESS,
        top: BLEED,
        left: BLEED + D - MATERIAL_THICKNESS,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "none",
        cameraRotationV: "none",
        lid: "current",
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + this.height}
            L ${this.left} ${this.top + this.height}
            Z
          `
        }
      },
      {
        name: "overlap",
        // row: 'first',
        print: true,
        printInside: false,
        width: L + 6*MATERIAL_THICKNESS,
        height: this.overlapHeight,
        top: BLEED + D - 2*MATERIAL_THICKNESS,
        left: BLEED + D - 3*MATERIAL_THICKNESS,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "front",
        cameraRotationV: "top",
        lid: "current",
        path: function () {
          return `
            M ${this.left + 2*MATERIAL_THICKNESS} ${this.top}
            L ${this.left + this.width - 2*MATERIAL_THICKNESS} ${this.top}
            L ${this.left + this.width} ${this.top + this.height}
            L ${this.left} ${this.top + this.height}
            L ${this.left + 2*MATERIAL_THICKNESS} ${this.top}
            Z
          `
        }
      },
      {
        name: "outsideFrontWall",
        // row: 'first',
        print: true,
        printInside: false,
        width: L + 6*MATERIAL_THICKNESS,
        height: D - MATERIAL_THICKNESS,
        top: BLEED + D - 2*MATERIAL_THICKNESS + this.overlapHeight,
        left: BLEED + D - 3*MATERIAL_THICKNESS,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "front",
        cameraRotationV: "middleHigh",
        lid: "closed",
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + this.height}
            L ${this.left} ${this.top + this.height}
            Z
          `
        }
      },
      {
        name: "frontRightFlap",
        // row: 'first',
        print: false,
        printInside: false,
        width: D - MATERIAL_THICKNESS,
        height: 2*D + 2*MATERIAL_THICKNESS,
        top: BLEED,
        left: BLEED + D - MATERIAL_THICKNESS + L + 2*MATERIAL_THICKNESS,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "none",
        cameraRotationV: "none",
        lid: "current",
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + this.height}
            L ${this.left + MATERIAL_THICKNESS} ${this.top + this.height}
            L ${this.left + 2*MATERIAL_THICKNESS} ${this.top + this.height - 2*MATERIAL_THICKNESS}
            L ${this.left + 2*MATERIAL_THICKNESS} ${this.top + D - 2*MATERIAL_THICKNESS + 3*MATERIAL_THICKNESS}
            L ${this.left} ${this.top + D - 2*MATERIAL_THICKNESS}
            L ${this.left} ${this.top}
            Z
          `
        }
      },
      {
        name: "leftOutsideWall",
        // row: 'first',
        print: true,
        printInside: false,
        width: D - 2*MATERIAL_THICKNESS,
        height: W + 2*MATERIAL_THICKNESS,
        top: BLEED + 2*D + 2*MATERIAL_THICKNESS,
        left: BLEED,
        angle: -90,
        insideAngle: 0,
        cameraRotationH: "left",
        cameraRotationV: "middleHigh",
        lid: "closed",
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + this.height}
            L ${this.left} ${this.top + this.height}
            Z
          `
        }
      },
      {
        name: "bottom",
        // row: 'first',
        print: true,
        printInside: false,
        width: L + 6*MATERIAL_THICKNESS,
        height: W + 6*MATERIAL_THICKNESS,
        top: BLEED + D - 2*MATERIAL_THICKNESS + 3*MATERIAL_THICKNESS + D - MATERIAL_THICKNESS,
        left: BLEED + D - 2*MATERIAL_THICKNESS - MATERIAL_THICKNESS,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "front",
        cameraRotationV: "low",
        lid: "closed",
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width - MATERIAL_THICKNESS} ${this.top + 2*MATERIAL_THICKNESS}
            L ${this.left + this.width - MATERIAL_THICKNESS} ${this.top + this.height - 2*MATERIAL_THICKNESS}
            L ${this.left + this.width} ${this.top + this.height}
            L ${this.left} ${this.top + this.height}
            L ${this.left + MATERIAL_THICKNESS} ${this.top + this.height - 2*MATERIAL_THICKNESS}
            L ${this.left + MATERIAL_THICKNESS} ${this.top + 2*MATERIAL_THICKNESS}
            L ${this.left} ${this.top}
            Z
          `
        }
      },
      {
        name: "rightOutsideWall",
        // row: 'first',
        print: true,
        printInside: false,
        width: D - 2*MATERIAL_THICKNESS,
        height: W + 2*MATERIAL_THICKNESS,
        top: BLEED + 2*D + 2*MATERIAL_THICKNESS,
        left: BLEED + D - 2*MATERIAL_THICKNESS + L + 2*MATERIAL_THICKNESS + 2*MATERIAL_THICKNESS,
        angle: 90,
        insideAngle: 0,
        cameraRotationH: "right",
        cameraRotationV: "middleHigh",
        lid: "closed",
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + this.height}
            L ${this.left} ${this.top + this.height}
            Z
          `
        }
      },
      {
        name: "backLeftFlap",
        // row: 'first',
        print: false,
        printInside: false,
        width: D - 3*MATERIAL_THICKNESS + 2*MATERIAL_THICKNESS,
        height: D + 3*MATERIAL_THICKNESS,
        top: BLEED + 2*D + 2*MATERIAL_THICKNESS + W + 2*MATERIAL_THICKNESS,
        left: BLEED,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "none",
        cameraRotationV: "none",
        lid: "closed",
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width - MATERIAL_THICKNESS} ${this.top}
            L ${this.left + this.width - 2*MATERIAL_THICKNESS} ${this.top + 2*MATERIAL_THICKNESS}
            L ${this.left + this.width - 2*MATERIAL_THICKNESS} ${this.top + this.height - 2*MATERIAL_THICKNESS - 2*MATERIAL_THICKNESS}
            L ${this.left + this.width} ${this.top + this.height - 2*MATERIAL_THICKNESS}
            L ${this.left + this.width} ${this.top + this.height}
            L ${this.left} ${this.top + this.height}
            L ${this.left} ${this.top}
            Z
          `
        }
      },
      {
        name: "backWall",
        // row: 'first',
        print: true,
        printInside: false,
        width: L + 6*MATERIAL_THICKNESS,
        height: D - MATERIAL_THICKNESS,
        top: BLEED + D - 2*MATERIAL_THICKNESS + 3*MATERIAL_THICKNESS + D - MATERIAL_THICKNESS + W + 6*MATERIAL_THICKNESS,
        left: BLEED + D - 3*MATERIAL_THICKNESS,
        angle: 180,
        insideAngle: 0,
        cameraRotationH: "back",
        cameraRotationV: "middleHigh",
        lid: "closed",
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + this.height - 2*MATERIAL_THICKNESS}
            L ${this.left + this.width - 2*MATERIAL_THICKNESS} ${this.top + this.height}
            L ${this.left + 2*MATERIAL_THICKNESS} ${this.top + this.height}
            L ${this.left} ${this.top + this.height - 2*MATERIAL_THICKNESS}
            L ${this.left} ${this.top}
            Z
          `
        }
      },
      {
        name: "backRightFlap",
        // row: 'first',
        print: false,
        printInside: false,
        width: D - 3*MATERIAL_THICKNESS + 2*MATERIAL_THICKNESS,
        height: D + 3*MATERIAL_THICKNESS,
        top: BLEED + 2*D + 2*MATERIAL_THICKNESS + W + 2*MATERIAL_THICKNESS,
        left: BLEED + D - 3*MATERIAL_THICKNESS + L + 4*MATERIAL_THICKNESS,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "none",
        cameraRotationV: "none",
        lid: "closed",
        path: function () {
          return `
            M ${this.left + MATERIAL_THICKNESS} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + this.height}
            L ${this.left} ${this.top + this.height}
            L ${this.left} ${this.top + this.height - 2*MATERIAL_THICKNESS}
            L ${this.left + 2*MATERIAL_THICKNESS} ${this.top + this.height - 2*MATERIAL_THICKNESS - 2*MATERIAL_THICKNESS}
            L ${this.left + MATERIAL_THICKNESS + MATERIAL_THICKNESS} ${this.top + 2*MATERIAL_THICKNESS}
            L ${this.left + MATERIAL_THICKNESS} ${this.top}
            Z
          `
        }
      },
      {
        name: "leftClosingFlap",
        // row: 'first',
        print: false,
        printInside: false,
        width: D - MATERIAL_THICKNESS,
        height: L + MATERIAL_THICKNESS,
        top: BLEED + 2*D + 2*MATERIAL_THICKNESS + W + 2*MATERIAL_THICKNESS + D + 3*MATERIAL_THICKNESS,
        left: BLEED,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "none",
        cameraRotationV: "none",
        lid: "open",
        point3: function () {
          return calculateSecondPointYFromAngleAndDistance(
            this.left + this.width,
            this.top + this.height,
            this.left + 1,
            15
          )
        },
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + this.height}
            L ${this.point3.x} ${this.point3.y}
            Q ${this.point3.x - 1} ${this.point3.y - 0.25} ${this.left} ${this.point3.y - 1}
            L ${this.left} ${this.top + 0.75*this.height}
            L ${this.left + CUT_OUT_WIDTH} ${this.top + 0.75*this.height}
            L ${this.left + CUT_OUT_WIDTH} ${this.top + 0.25*this.height}
            L ${this.left} ${this.top + 0.25*this.height}
            L ${this.left} ${this.top}
            Z
          `
        }
      },
      {
        name: "top",
        // row: 'first',
        print: true,
        printInside: false,
        width: L + 2*MATERIAL_THICKNESS,
        height: W + 3*MATERIAL_THICKNESS + 0.5,
        top: BLEED + D - 2*MATERIAL_THICKNESS + 3*MATERIAL_THICKNESS + D - MATERIAL_THICKNESS + W + 6*MATERIAL_THICKNESS + D - MATERIAL_THICKNESS,
        left: BLEED + D - MATERIAL_THICKNESS,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "front",
        cameraRotationV: "top",
        lid: "closed",
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + this.height - 0.5}
            L ${this.left + this.width / 2 + 0.5} ${this.top + this.height - 0.5}
            Q ${this.left + this.width / 2 + 0.5} ${this.top + this.height} ${this.left + this.width / 2} ${this.top + this.height}
            Q ${this.left + this.width / 2 - 0.5} ${this.top + this.height} ${this.left + this.width / 2 - 0.5} ${this.top + this.height - 0.5}
            L ${this.left} ${this.top + this.height - 0.5}
            L ${this.left} ${this.top}
            Z
          `
        }
      },
      {
        name: "rightClosingFlap",
        // row: 'first',
        print: false,
        printInside: false,
        width: D - MATERIAL_THICKNESS,
        height: L + MATERIAL_THICKNESS,
        top: BLEED + 2*D + 2*MATERIAL_THICKNESS + W + 2*MATERIAL_THICKNESS + D + 3*MATERIAL_THICKNESS,
        left: BLEED + D - MATERIAL_THICKNESS + L + 2*MATERIAL_THICKNESS,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "none",
        cameraRotationV: "none",
        lid: "open",
        point7: function () {
          return calculateSecondPointYFromAngleAndDistance(
            this.left,
            this.top + this.height,
            this.left + this.width - 1,
            -15
          )
        },
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.left + this.width} ${this.top + this.height * 0.25}
            L ${this.left + this.width - 0.75} ${this.top + this.height * 0.25}
            L ${this.left + this.width - 0.75} ${this.top + this.height * 0.75}
            L ${this.left + this.width} ${this.top + this.height * 0.75}
            L ${this.point7.x + 1} ${this.point7.y - 1}
            Q ${this.point7.x + 1} ${this.point7.y - 0.25} ${this.point7.x} ${this.point7.y}
            L ${this.left} ${this.top + this.height}
            L ${this.left} ${this.top}
            Z
          `
        }
      },
      {
        name: "frontClosingFlap",
        // row: 'first',
        print: false,
        printInside: false,
        width: L + 2*MATERIAL_THICKNESS,
        height: D - MATERIAL_THICKNESS,
        top: BLEED + D - 2*MATERIAL_THICKNESS + 3*MATERIAL_THICKNESS + D - MATERIAL_THICKNESS + W + 6*MATERIAL_THICKNESS + D - MATERIAL_THICKNESS + W + 3*MATERIAL_THICKNESS,
        left: BLEED + D - MATERIAL_THICKNESS,
        angle: 0,
        insideAngle: 0,
        cameraRotationH: "none",
        cameraRotationV: "none",
        lid: "open",
        point5: function () {
          return calculateSecondPointXFromAngleAndDistance(
            this.left + this.width,
            this.top,
            this.top + this.height - 1,
            105
          )
        },
        point12: function () {
          return calculateSecondPointXFromAngleAndDistance(
            this.left,
            this.top,
            this.top + this.height - 1,
            -105
          )
        },
        path: function () {
          return `
            M ${this.left} ${this.top}
            L ${this.left + this.width / 2 - 0.5} ${this.top}
            Q ${this.left + this.width / 2 - 0.5} ${this.top + 0.5} ${this.left + this.width / 2} ${this.top + 0.5}
            Q ${this.left + this.width / 2 + 0.5} ${this.top + 0.5} ${this.left + this.width / 2 + 0.5} ${this.top}
            L ${this.left + this.width} ${this.top}
            L ${this.point5.x} ${this.point5.y}
            Q ${this.point5.x - 0.25} ${this.point5.y + 1} ${this.point5.x - 1} ${this.point5.y + 1}
            L ${this.left + this.width * 0.75} ${this.top + this.height}
            L ${this.left + this.width * 0.75} ${this.top + this.height - CUT_OUT_WIDTH}
            L ${this.left + this.width * 0.25} ${this.top + this.height - CUT_OUT_WIDTH}
            L ${this.left + this.width * 0.25} ${this.top + this.height}
            L ${this.point12.x + 1} ${this.point12.y + 1}
            Q ${this.point12.x + 0.25} ${this.point12.y + 1} ${this.point12.x} ${this.point12.y}
            L ${this.left} ${this.top}
            Z
          `
        }
      },
    ]

    // debug
    // let _panels = panels.map((panel) => new Panel(panel));
    // console.log(_panels[1])

    // initialize and return panels
    return panels.map((panel) => new Panel(panel));
  }

  // @TODO improve
  setFlapDimensions() {
    const bottomHeight = MATERIAL_THICKNESS + this.length + MATERIAL_THICKNESS;
    const outsideWallWidth = MATERIAL_THICKNESS + this.depth + MATERIAL_THICKNESS

    this.flapWidth = Math.min((bottomHeight / 2), outsideWallWidth);

    this.flapWidthInPx = this.flapWidth * this.pixelsPerInch;
  }

  /**
   * Calculates the total width of the SVG document for the mailer box.
   * This width includes all panels and optionally the bleed areas.
   *
   * Calculation Formula:
   * ```
   * B + (3MT + D + MT) + (5MT) + (MT + D + MT) + (7MT + W + 7MT) + (MT + D + MT) + (5MT) + (MT + D + 3MT) + B
   * => 2B + 36MT + 4D + W
   * ```
   * Where:
   * - B (Bleed): Additional space around the document for printing purposes, in inches.
   * - MT (Material Thickness): Thickness of the material used, in inches.
   * - D (Depth): Depth of the box, in inches.
   * - W (Width): Width of the box, in inches.
   *
   * @param {boolean} withBleed - Optional. Whether to include bleed in the width calculation. Defaults to true.
   * @return {number} The total width of the document, in inches.
   */
  getDocumentWidth(withBleed = true) {
    let _bleed = withBleed ? 2 * this.bleed : 0
    return _bleed + 2*this.depth + this.length;
  }

  /**
   * Calculates the total height of the SVG document for the mailer box.
   * This hight includes all panels and optionally the bleed.
   *
   * Calculation Formula:
   * ```
   * B + (D) + (3MT + L + MT) + (MT + D + MT) + (MT + L + MT) + (MT + D) + B
   * => 2B + 9MT + 3D + 2L
   * ```
   * Where:
   * - B (Bleed): Additional space around the document for printing purposes, in inches.
   * - MT (Material Thickness): Thickness of the material used, in inches.
   * - D (Depth): Depth of the box, in inches.
   * - L (Lenght): Lenght of the box, in inches.
   *
   * @param {boolean} withBleed - Optional. Whether to include bleed in the height calculation. Defaults to true.
   * @return {number} The total height of the document, in inches.
   */
  getDocumentHeight(withBleed = true) {
    let _bleed = withBleed ? 2 * this.bleed : 0
    return _bleed + 4*this.depth + this.width + this.length + 7*MATERIAL_THICKNESS;
  }

  /**
   * Calculates the X coordinate of the vertical guide line.
   * The guide line is positioned at the horizontal midpoint of the document.
   *
   * @TODO rename to something like 'guideX'
   *
   * @return {number} The X coordinate for the vertical guide line.
   */
  getGuideX() {
    return this.getDocumentWidth() / 2;
  }

  /**
   * Calculates the Y coordinate of the horizontal guide line.
   * The guide line is positioned at the vertical midpoint of the bottom panel (bottom side of the box).
   *
   * @TODO rename to something like 'guideY'
   *
   * @return {number} The Y coordinate for the horizontal guide line.
   */
  getGuideY() {
    return this.bleed + (MATERIAL_THICKNESS + this.depth) + (MATERIAL_THICKNESS + this.width + MATERIAL_THICKNESS) / 2;
  }

  /**
   * Retrieves the X and Y coordinates for the guide point, which determines where guide lines intersect.
   *
   * @TODO rename to something like 'guidePoint'
   *
   * @return {{x: number, y: number}} An object containing both X and Y coordinates for the guide point.
   */
  getGuidePoint() {
    return {
      x: this.getGuideX(),
      y: this.getGuideY(),
    }
  }

  setCanvasDimensions() {
    // canvas width
    this.canvasWidth = toPx(this.getDocumentWidth());
    // console.log('document width (in)', this.getDocumentWidth());
    // console.log('canvas width (px)', this.canvasWidth);

    // canvas height
    this.canvasHeight = toPx(this.getDocumentHeight());
    // console.log('document height (in)', this.getDocumentHeight());
    // console.log('canvas height (px)', this.canvasHeight);

    // normalized canvas ratio
    // value between 0 and 1
    this.ratio = this.canvasWidth > this.canvasHeight ?
      this.canvasHeight / this.canvasWidth : this.canvasWidth / this.canvasHeight;
  }

  getGeometrySvg() {
    return svgGenerator.getSvgForGeom(this)
  }

  get2DEditorSvg(printSide = 'outside') {
    return svgGenerator.get2DEditorSvg(this, printSide)
  }

  getOutlinePathWithBleed() {
    return ''
  }

  getNormalizedOutlinePathWithBleed(printSide = 'outside') {
    return svgGenerator.getOutlineWithBleed(this, true, printSide)
  } 

  getOutlinePathWithoutNonPrintPanels(printSide = 'outside') {
    return svgGenerator.getOutlineWithoutNonPrintPanels(this, false, printSide)
  }

  getOutlinePath() {
    return svgGenerator.getOutline(this)
  }

  getCutlinesPath() {
    return svgGenerator.getCutlines(this)
  }

}

export default PizzaBox;
